import { render, staticRenderFns } from "./PersonSelect.vue?vue&type=template&id=0086bf19&scoped=true"
import script from "./PersonSelect.vue?vue&type=script&lang=js"
export * from "./PersonSelect.vue?vue&type=script&lang=js"
import style0 from "./PersonSelect.vue?vue&type=style&index=0&id=0086bf19&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0086bf19",
  null
  
)

export default component.exports